<!-- 图文详情 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <!-- ========== 定制模式：id=1102 时显示3个独立场景编辑 ========== -->
                    <template v-if="isSceneMode">
                        <div class="menu-div">
                            <div
                                :class="
                                    scene_id == 0
                                        ? 'menuitem-div-active'
                                        : 'menuitem-div'
                                "
                                @click="changeScene(0)"
                            >
                                普通中空质保书
                            </div>
                            <div
                                :class="
                                    scene_id == 1
                                        ? 'menuitem-div-active'
                                        : 'menuitem-div'
                                "
                                @click="changeScene(1)"
                            >
                                4SG玻璃质保书
                            </div>
                            <div
                                :class="
                                    scene_id == 2
                                        ? 'menuitem-div-active'
                                        : 'menuitem-div'
                                "
                                @click="changeScene(2)"
                            >
                                感谢文案
                            </div>
                        </div>
                        <Form
                            :model="newFormData"
                            label-position="right"
                            :label-width="80"
                        >
                            <editor
                                class="editor-div"
                                :edtor-con="currentSceneText"
                                :index="scene_id + 1"
                                @getContent="getSceneContent"
                                @getContentchange="getSceneContent"
                            />
                            <div class="form-title">按钮设置</div>
                            <FormItem label="是否展开">
                                <i-switch
                                    v-model="
                                        newFormData.content.scenes[scene_id]
                                            .btn_value
                                    "
                                    size="large"
                                    true-color="#FF761D "
                                    :true-value="1"
                                    :false-value="0"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </FormItem>
                            <template
                                v-if="
                                    newFormData.content.scenes[scene_id]
                                        .btn_value
                                "
                            >
                                <FormItem label="按钮颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.scenes[scene_id]
                                                .btn_color
                                        "
                                /></FormItem>
                                <FormItem label="边框颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.scenes[scene_id]
                                                .border_color
                                        "
                                /></FormItem>
                                <FormItem label="文字颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.scenes[scene_id]
                                                .btn_text_color
                                        "
                                /></FormItem>
                                <FormItem label="蒙版颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.scenes[scene_id]
                                                .mask_color
                                        "
                                /></FormItem>
                            </template>
                            <div class="form-title mt24">背景设置</div>
                            <FormItem label="背景颜色">
                                <ColorPicker
                                    v-model="newFormData.content.bg_color"
                            /></FormItem>
                            <FormItem label="背景图">
                                <i-switch
                                    v-model="newFormData.content.bg_value"
                                    size="large"
                                    true-color="#FF761D "
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="changeBgValue"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </FormItem>
                            <FormItem
                                v-if="newFormData.content.bg_value"
                                label="上传背景"
                            >
                                <div
                                    class="bg-upload"
                                    @click="openModal('bg_img')"
                                >
                                    <img
                                        class="bg-img"
                                        v-if="
                                            newFormData.content.bg_img.picview
                                        "
                                        :src="
                                            newFormData.content.bg_img.picview
                                        "
                                    />
                                    <Icon
                                        v-else
                                        type="md-add"
                                        size="30"
                                        color="#ccc"
                                    />
                                </div>
                            </FormItem>
                        </Form>
                    </template>
                    <!-- ========== 原有模式：普通模板选择 ========== -->
                    <template v-else>
                        <Form
                            :model="newFormData"
                            label-position="right"
                            :label-width="80"
                        >
                            <editor
                                class="editor-div"
                                :edtor-con="newFormData.content.text"
                                :index="1"
                                @getContent="getEnContent"
                                @getContentchange="getEnContentchange"
                            />
                            <div class="form-title">按钮设置</div>
                            <FormItem label="是否展开">
                                <i-switch
                                    v-model="newFormData.content.btn_value"
                                    size="large"
                                    true-color="#FF761D "
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="changeBtn"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </FormItem>
                            <template v-if="newFormData.content.btn_value">
                                <FormItem label="按钮颜色"
                                    ><ColorPicker
                                        v-model="newFormData.content.btn_color"
                                /></FormItem>
                                <FormItem label="边框颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.border_color
                                        "
                                /></FormItem>
                                <FormItem label="文字颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.btn_text_color
                                        "
                                /></FormItem>
                                <FormItem label="蒙版颜色"
                                    ><ColorPicker
                                        v-model="
                                            newFormData.content.mask_color
                                        "
                                /></FormItem>
                            </template>
                            <div class="form-title mt24">背景设置</div>
                            <FormItem label="背景颜色">
                                <ColorPicker
                                    v-model="newFormData.content.bg_color"
                            /></FormItem>
                            <FormItem label="背景图">
                                <i-switch
                                    v-model="newFormData.content.bg_value"
                                    size="large"
                                    true-color="#FF761D "
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="changeBgValue"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </FormItem>
                            <FormItem
                                v-if="newFormData.content.bg_value"
                                label="上传背景"
                            >
                                <div
                                    class="bg-upload"
                                    @click="openModal('bg_img')"
                                >
                                    <img
                                        class="bg-img"
                                        v-if="
                                            newFormData.content.bg_img.picview
                                        "
                                        :src="
                                            newFormData.content.bg_img.picview
                                        "
                                    />
                                    <Icon
                                        v-else
                                        type="md-add"
                                        size="30"
                                        color="#ccc"
                                    />
                                </div>
                            </FormItem>
                        </Form>
                    </template>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { editor, pictureLibrary },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
        // DIY页面ID，用于判断是否需要显示多场景定制UI（id=1102时启用3场景模式）
        pageId: {
            type: String,
            default: "1102",
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            scene_id: 0, // 当前选中的场景索引：0=场景一, 1=场景二, 2=场景三
        };
    },
    computed: {
        // 是否启用多场景定制模式（id=1102）
        isSceneMode() {
            return String(this.pageId) === "1102";
        },
        // 当前场景的文本内容
        currentSceneText() {
            if (
                this.isSceneMode &&
                this.newFormData.content &&
                Array.isArray(this.newFormData.content.scenes)
            ) {
                const scene = this.newFormData.content.scenes[this.scene_id];
                return scene ? scene.text : "";
            }
            return "";
        },
    },
    mounted() {
        this.initScenes();
    },
    methods: {
        // 初始化3场景数据（仅id=1102时生效）
        initScenes() {
            if (!this.isSceneMode) return;
            const content = this.newFormData.content;
            if (!content) return;
            // 如果还没有 scenes 数组，创建默认3场景数据
            if (!Array.isArray(content.scenes) || content.scenes.length === 0) {
                this.$set(content, "scenes", [
                    {
                        text: "场景一图文内容",
                        btn_value: 0,
                        btn_color: "#fff",
                        border_color: "#FF761D",
                        btn_text_color: "#FF761D",
                        mask_color: "#FFF8F4",
                    },
                    {
                        text: "场景二图文内容",
                        btn_value: 0,
                        btn_color: "#fff",
                        border_color: "#FF761D",
                        btn_text_color: "#FF761D",
                        mask_color: "#FFF8F4",
                    },
                    {
                        text: "场景三图文内容",
                        btn_value: 0,
                        btn_color: "#fff",
                        border_color: "#FF761D",
                        btn_text_color: "#FF761D",
                        mask_color: "#FFF8F4",
                    },
                ]);
            }
            // 确保 scene_value 字段存在
            if (
                content.scene_value === undefined ||
                content.scene_value === null
            ) {
                this.$set(content, "scene_value", 1);
            }
        },
        // 切换场景（同步更新手机预览）
        changeScene(index) {
            this.scene_id = index;
            // 同步更新 content.scene_value，使手机预览组件能读取当前场景
            if (this.newFormData.content) {
                this.$set(this.newFormData.content, "scene_value", index + 1);
            }
        },
        // 场景富文本内容更新
        getSceneContent(detailData) {
            if (
                this.isSceneMode &&
                this.newFormData.content &&
                Array.isArray(this.newFormData.content.scenes)
            ) {
                this.$set(
                    this.newFormData.content.scenes[this.scene_id],
                    "text",
                    detailData.editorData
                );
            }
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        //富文本
        getEnContentchange(detailData) {
            this.newFormData.content.text = detailData.editorData;
        },
        getEnContent(detailData) {
            this.newFormData.content.text = detailData.editorData;
        },
        changeBtn(e) {
            this.newFormData.content.btn_value = e;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.editor-div {
    width: 100%;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.menu-div {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 118, 29, 0.1);
    border-radius: 6px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #747b95;
    padding: 3px 6px;
    cursor: pointer;
}
.menuitem-div-active {
    flex: 1;
    text-align: center;
    background: #ff761d;
    border-radius: 6px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    padding: 6px 24px;
}
.menuitem-div {
    flex: 1;
    text-align: center;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>